import { ACCOUNT_STOP_OUT_LEVEL_VALUES } from './settingsConstants';
import { ISettingsState } from './types/settings.t';
import { ILoadSettingsPayload, ISetSettingsParamPayload, IUpdateSettingsStartPayload } from './types/settingsActions.t';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: ISettingsState = {
    isLoading: false,
    params: {
        stop_out_level: ACCOUNT_STOP_OUT_LEVEL_VALUES.DEFAULT,
    },
};

export const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        loadSettingsAction(state, action: PayloadAction) {
            state.isLoading = true;
        },
        updateSettingsAction(state, action: PayloadAction<IUpdateSettingsStartPayload>) {
            state.isLoading = true;
        },
        loadSettingsSuccess(state, action: PayloadAction<ILoadSettingsPayload>) {
            state.isLoading = false;
            state.params = { ...state.params, ...action.payload };
        },
        updateSettingsSuccess(state, action: PayloadAction<ILoadSettingsPayload>) {
            state.isLoading = false;
            state.params = { ...state.params, ...action.payload };
        },
        loadSettingsFailure(state, action: PayloadAction) {
            state.isLoading = false;
        },
        updateSettingsFailure(state, action: PayloadAction) {
            state.isLoading = false;
        },
        setSettingsParamsAction(state, action: PayloadAction<ISetSettingsParamPayload>) {
            state.params = { ...state.params, ...action.payload };
        },
    },
});

export default settingsSlice.reducer;
